/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { List, ListItem, Button } from '@mui/material';
import useClasses from '../../../../../../helpers/useClasses';

const styles = theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: '#fff',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: '#fff',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: '#fff',
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: '#fff'
    }
  }
});

const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { pages, className, ...rest } = props;

  const classes = useClasses(styles);

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      {pages.map(page => (
        <ListItem
          // className={classes.item}
          disableGutters
          key={page.title}
          sx={{
            display: 'flex',
            paddingTop: 0,
            paddingBottom: 0
          }}
        >
          <Button
            // activeClassName={classes.active}
            // className={classes.button}
            component={CustomRouterLink}
            to={page.href}
            sx={{
              color: '#fff',
              padding: '10px 8px',
              justifyContent: 'flex-start',
              textTransform: 'none',
              letterSpacing: 0,
              width: '100%',
              fontWeight: 'medium'
            }}
          >
            <div className={classes.icon}>{page.icon}</div>
            {page.title}
            {page.badge ? (
              <span
                style={{
                  marginLeft: 'auto',
                  fontSize: '10px',
                  fontWeight: 700,
                  letterSpacing: '0.5px',
                  backgroundColor: '#ffffff',
                  color: '#17507f',
                  padding: '2px 6px',
                  borderRadius: '10px'
                }}
              >
                {page.badge}
              </span>
            ) : null}
          </Button>
        </ListItem>
      ))}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
